import React from 'react';
import { IonItem, IonLabel, IonInput } from '@ionic/react';
import { pxToRem } from '@/modules/config';
import type { TopicType, TopicTypeId } from '../types';
import { fieldLabelStyle } from '../read/styles';
import { visuallyHiddenInputStyle } from './constants';

interface TitleAndTypeBlockProps {
  topicTitle: string;
  setTopicTitle: (value: string) => void;
  type: TopicTypeId;
  setType: (value: TopicTypeId) => void;
  enabledTypes: readonly TopicType[];
}

/**
 * Editable topic title field + the type-selection chips — the legacy path's
 * first body of `TopicBasicsBlock`'s card.
 */
const TitleAndTypeBlock: React.FC<TitleAndTypeBlockProps> = ({
  topicTitle,
  setTopicTitle,
  type,
  setType,
  enabledTypes,
}) => (
  <>
    <IonItem lines="inset">
      <IonLabel position="stacked" className="topic-form-label">
        Topic Title *
      </IonLabel>
      <IonInput
        value={topicTitle}
        onIonInput={e => setTopicTitle((e.detail.value as string) || '')}
        placeholder="Enter topic title"
        maxlength={64}
      />
    </IonItem>
    <div style={{ padding: '12px 16px' }}>
      <p
        className="topic-form-label"
        style={{ ...fieldLabelStyle, marginBottom: 8 }}
      >
        Type
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {enabledTypes.map(t => {
          const active = type === t.id;
          return (
            <button
              key={t.id}
              data-testid={`topic-type-chip-${t.id}`}
              onClick={() => setType(t.id)}
              style={{
                padding: '5px 14px',
                borderRadius: 16,
                border: active ? '1.5px solid #D85A30' : '1.5px solid #ccc',
                background: active ? '#FAECE7' : 'transparent',
                color: active ? '#993C1D' : 'inherit',
                cursor: 'pointer',
                fontSize: pxToRem(14),
              }}
            >
              {t.choiceLabel}
            </button>
          );
        })}
      </div>
    </div>
    <input
      type="text"
      data-testid="topic-title-input"
      value={topicTitle}
      onInput={e => setTopicTitle((e.target as HTMLInputElement).value || '')}
      onChange={e => setTopicTitle(e.target.value)}
      style={visuallyHiddenInputStyle}
      aria-hidden="true"
      tabIndex={-1}
    />
  </>
);

export default TitleAndTypeBlock;
